import React from 'react';

function AttendanceRiskSummaryStrip({ cards = [] }) {
  return (
    <div className="summary-grid">
      {cards.map(card => (
        <div className="summary-card" key={card.label}>
          <span className="summary-card-label">{card.label}</span>
          <strong>{card.value}</strong>
        </div>
      ))}
    </div>
  );
}

export default AttendanceRiskSummaryStrip;
